module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo8-f414d12701deaf9b8c4c6f8c297c4c2b.jpg";